import { useLocalObservable } from 'mobx-react-lite';
import { createContext, useContext } from 'react';
import { ProfilePortfolioStore } from 'modules/profile/stores/ProfilePortfolioStore';
import { useApi } from 'providers/ApiProvider';
import { useStaticData } from 'providers/StaticDataStoreProvider';

const profilePortfolioStoreContext = createContext<ProfilePortfolioStore>(
  {} as ProfilePortfolioStore
);

export const ProvideProfilePortfolioStore = ({ children }: any) => {
  const api = useApi();
  const staticData = useStaticData();
  const store = useLocalObservable(
    () => new ProfilePortfolioStore(api, staticData)
  );

  return (
    <profilePortfolioStoreContext.Provider value={store}>
      {children}
    </profilePortfolioStoreContext.Provider>
  );
};

export const useProfilePortfolioStore = () => {
  return useContext(profilePortfolioStoreContext);
};
